export default "curl -X POST {{url}} -H \"api-key: {{apiKey}}\" -F \"image=@{{path}}\"\n"